export default "__VITE_ASSET__86129b89__"